const initialState = {
  imageCards: {},
};

export default function reducer(state = initialState, action = {}) {
  const imageCards = state.imageCards;

  switch (action.type) {
    case 'IMAGE_STYLE_CHANGED':
      if (!imageCards[action.id]) {
        imageCards[action.id] = {};
      }

      imageCards[action.id].style = action.style;

      return Object.assign({}, state, {
        imageCards,
      });

    case 'SHOW_IMAGE_CREDITS':
      if (!imageCards[action.id]) {
        imageCards[action.id] = {};
      }

      imageCards[action.id].showCredits = true;

      return Object.assign({}, state, {
        imageCards,
      });

    case 'TRANSITION_IN_IMAGE_CREDITS':
      if (!imageCards[action.id]) {
        imageCards[action.id] = {};
      }

      imageCards[action.id].transitionInCredits = true;

      return Object.assign({}, state, {
        imageCards,
      });

    case 'HIDE_IMAGE_CREDITS':
      if (!imageCards[action.id]) {
        imageCards[action.id] = {};
      }

      imageCards[action.id].showCredits = false;

      return Object.assign({}, state, {
        imageCards,
      });

    case 'TRANSITION_OUT_IMAGE_CREDITS':
      if (!imageCards[action.id]) {
        imageCards[action.id] = {};
      }

      imageCards[action.id].transitionInCredits = false;

      return Object.assign({}, state, {
        imageCards,
      });

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./assets/js/src/reducers/small-image-card.js
 **/